import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, role }) {
  const { user, bootstrapped } = useAuth();
  if (!bootstrapped || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white text-slate-900" data-testid="auth-loading">
        <div className="font-mono text-xs tracking-[0.3em] text-slate-500 animate-pulse">[ AUTHENTICATING ]</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  // Role hierarchy: super_admin > admin > client
  const isSuperAdmin = user.role === "super_admin";
  const isAdminOrSuper = user.role === "admin" || isSuperAdmin;

  if (role === "super_admin" && !isSuperAdmin) {
    // Admin tried to access money screens — bounce them to admin dashboard
    return <Navigate to={user.role === "admin" ? "/admin" : "/dashboard"} replace />;
  }
  if (role === "admin" && !isAdminOrSuper) {
    return <Navigate to="/dashboard" replace />;
  }
  if (role === "client" && isAdminOrSuper) {
    return <Navigate to={isSuperAdmin ? "/super-admin" : "/admin"} replace />;
  }
  return children;
}
